import { SecurityRegistryRecord } from "@models/shares/security-registry-record";

export function filterRecordsWithEmptyHoldings(records: SecurityRegistryRecord[]): SecurityRegistryRecord[] {
  return records
    // Filter records with no holders AND negative or zero holding numbers
    .filter((record: SecurityRegistryRecord) => record.holders.length)
    .filter((record: SecurityRegistryRecord) => !record.holdings.every((holding) => holding.number <= 0))
    // Filter holding with number equals to zero
    .map((record: SecurityRegistryRecord) => {
      record.holdings = record.holdings.filter((holding) => holding.number);
      return record;
    })
    // Filter records with no holdings
    .filter((record) => record.holdings.length);
}
